export const ASKZOYA_CONST = {
  searchType: {
    flights: "flights",
    hotels: "hotels",
  },
  localStorageKey: {
    flights: "_zenvoya_flight_chat_data",
    hotels: "_zenvoya_hotel_chat_data",
  },
  streamingKey: {
    done: "[DONE]",
    completed: "completed",
    status: "status",
    connected: "connected",
    error: "error",
  },
  chatInput: {
    placeholder: "Ask a question about these results",
  },
};
